<template>
  <div v-if="isPopupOpen" class="layer-popup-view">
    <div :class="isModal ? 'modal' : 'full-layer'">
      <component
        :is="layerPopup"
        :key="`layer-popup__${isModal ? 'modal' : 'full-popup'}`"
        :payloads="payloads"
        @on-close="onClickClose"
        @on-cancel="onClickCancel"
      />
    </div>
  </div>
</template>
<script setup>
  import { computed, watch } from 'vue'
  import { useRouter } from 'vue-router/composables'
  import { useLayerPopupLoader } from '@/common/use/useLayerPopupLoader'
  import { setDisableScrolling } from '@/common/utils/common'

  const router = useRouter()
  const { layerPopup, isPopupOpen, payloads } = useLayerPopupLoader()

  const isModal = computed(() =>
    layerPopup.value?.__name.toLowerCase()?.includes('modal'),
  )

  const onClickClose = () => {
    router.back()
  }

  const onClickCancel = () => {
    isPopupOpen.value = false
  }

  watch(
    () => isPopupOpen.value,
    () => setDisableScrolling(isPopupOpen.value),
  )
</script>
<style lang="scss" scoped>
  .layer-popup-view {
    .modal {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.8);
      z-index: 2000;
    }
  }
</style>
